// Core
import React, {useEffect} from "react"
import { isMobile } from "react-device-detect"

// Components
import ScrollSection from "../locomotiveScroll/scrollSection"
import JsonText from "../_jsonText"

// Style
import styles from "./writtenInterview.module.scss"

const WrittenInterview = ({ count, scrollEvent, contentful_id, menuTitle, subheading, heading, content, posterImage}) => {
  const anchorOverride = menuTitle ? menuTitle.replace(/\s+/g, '-').toLowerCase() : null

  useEffect(() => {
    setTimeout(() => {
      if (!isMobile && scrollEvent) {
        window.scroll.on('call', (value, way, obj) => {
          if (value === "written-interview-" + contentful_id) scrollEvent(way, count, obj)
        })
      }
    }, 200)
  }, [])

  return (
    <ScrollSection>
      <div
        id={`ep-${anchorOverride ? anchorOverride : "written-interview"}`}
        className={`${styles.wrap} container`}
        data-scroll
        data-scroll-call={`written-interview-${contentful_id}`}
        data-scroll-offset="45%, 45%"
        >
        <div className={`cols flex`}>
          <div className={`${styles.imageCol} col m8 tp6 t4 d3`}>
            <div id={`written-interview-sticky-target-${contentful_id}`} className={styles.imageStickyWrap}>
              <div data-scroll data-scroll-sticky data-scroll-target={`#written-interview-sticky-target-${contentful_id}`}>
                <img
                  src={posterImage.fluid.src}
                  className={`${styles.image}`}
                  width={888}
                  height={500}
                  alt={posterImage.description}
                  />
                <p className={`mono`}>{posterImage.description}</p>
              </div>
            </div>
          </div>
          <div className={`${styles.contentCol} col m12 t5 d4`}>
            <div className={styles.content}>
              <p className={`${styles.mono} mono`}>{subheading ? subheading : "In conversation with"}</p>
              {content ? (
                <React.Fragment>
                  <h3>{heading}</h3>
                  <JsonText {...content} />
                </React.Fragment>
              ) : (
                <h3>{heading}</h3>
              )}
            </div>
          </div>
        </div>
      </div>
    </ScrollSection>
  )
}

export default WrittenInterview